import { Button, Cascader, CascaderProps, Flex, Tooltip } from "antd";
import React, { useMemo } from "react";

interface SiteTeamSelectorProps {
  sites?: any[];
  teams?: any[];
  disabled?: boolean;
  onChange?: (siteId: string, teamId: string) => void;
  value?: { siteId?: string; teamId?: string };
}

// Google Maps Pin SVG as a React component
const GoogleMapIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="2em"
    height="2em"
    viewBox="0 0 24 24"
    fill="green"
  >
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5s2.5 1.12 2.5 2.5S13.38 11.5 12 11.5z" />
  </svg>
);

export default function SiteTeamSelector({
  sites = [],
  teams = [],
  disabled,
  onChange,
  value,
}: SiteTeamSelectorProps) {
  const cascaderOptions = useMemo(() => {
    return sites.map((site) => ({
      value: site.id,
      label: site.name,
      children: teams
        .filter((t: any) => t.siteId === site.id)
        .map((team: any) => ({
          value: team.id,
          label: team.name,
        })),
    }));
  }, [sites, teams]);

  const handleChange: CascaderProps["onChange"] = (values) => {
    const [selectedSiteId, selectedTeamId] = values as string[];
    if (onChange) {
      onChange(selectedSiteId, selectedTeamId);
    }
  };

  const cascaderValue = value?.siteId && value?.teamId
    ? [value.siteId, value.teamId]
    : value?.siteId
    ? [value.siteId]
    : [];

  return (
    <Flex align="center" gap={4}>
      <Cascader
        options={cascaderOptions}
        onChange={handleChange}
        value={cascaderValue}
        changeOnSelect
        disabled={disabled}
        placeholder="Select Site and Team"
        dropdownRender={(menu) => menu}
      >
        <Tooltip title="Select Site and Team">
          <Button
            icon={<GoogleMapIcon />}
            variant="outlined"
            disabled={disabled}
            size="large"
          />
        </Tooltip>
      </Cascader>
    </Flex>
  );
}
